import { render, staticRenderFns } from "./assessor-base.vue?vue&type=template&id=e7bd1476&"
import script from "./assessor-base.vue?vue&type=script&lang=js&"
export * from "./assessor-base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports